module.exports = ".mat-body-2 {\n  font-weight: normal; }\n\n.mat-dialog-content p {\n  font-weight: inherit;\n  /* keeps parent style */ }\n"